globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};
appCustomerSpace.LimitlessPlugins.TimePickers = appCustomerSpace.LimitlessPlugins.TimePickers || {};

appCustomerSpace.LimitlessPlugins.TimePickers.Single = (function(){

  Single.selector = '[data-plugin="limitless.timepickers.single"]';

  Single.init = function($html) {
    $html.find(Single.selector).each(function() {
      new Single($(this));
    })
  }

  function Single($html) {
    this.$html = $html;
    this.init();
  }

  Single.prototype = {
    init: function(){
      var Single = this,
          options = Single.$html.data('plugin-options') || {},
          defaults = {
            timeFormat: 'H:i',
            disableTextInput: true,
            step: 10,
          };

      Single.$html.timepicker($.extend({}, defaults, options, true));
    }
  }

  return Single;
})();
